import React from "react";
import {graphql} from "react-apollo";
import {connect} from "react-redux";
import TransferActionForm from "../../stockTransfers/forms/TransferActionForm";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

// A confirm-style window (Ship, Cancel, Remove pallet) around one mutation.
// Every server error is listed as the form's error, one per line: shipping is
// refused per serial number or per sku, which no field could hold.
//
//   mutation    — the gql document, taking `$data`
//   resultField — the mutation's field in the response
//   buildData   — (props, values) => the mutation input
//   formProps   — (props) => props for TransferActionForm (message, submitLabel, withReason)
//   success, cancel — action creators closing the window
export default function actionFormContainer({mutation, resultField, buildData, formProps, success, cancel}) {

  class ActionFormContainer extends React.Component {

    constructor(props) {
      super(props);
      this.state = { errors: [] }
    }

    handleSubmit(values) {
      return this.props.mutate({variables: {data: buildData(this.props, values)}})
        .then((response) => {
          const errors = response.data[resultField].errors;
          if (errors.length <= 0) {
            this.props.success();
          } else {
            this.setState({errors: createValidationErrors(errors, errors.map((error) => error.message).join("\n"))});
          }
        })
        .catch((err) => {
          this.setState({errors: createErrors(err)});
        });
    }

    render() {
      return (
        <TransferActionForm
          {...formProps(this.props)}
          errors={this.state.errors}
          onSubmit={this.handleSubmit.bind(this)}
          onCancel={() => this.props.cancel()}
          />
      )
    }
  }

  return connect(null, {success, cancel})(graphql(mutation)(ActionFormContainer));
}
